package pl.decks.personal.components.widgets.button

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.style.addVariantBase
import pl.decks.personal.styles.SiteLayout

object ButtonStylesheet {

    val CircleVariant = ButtonStyle.addVariantBase {
        Modifier
            .aspectRatio(1)
            .padding(SiteLayout.Space.none)
            .borderRadius(SiteLayout.Fraction.Half)
            .flexShrink(0)
            .flexGrow(0)
    }

    val GhostVariant = ButtonStyle.addVariantBase {
        Modifier.setVariable(ButtonVars.BackgroundDefaultColor, Colors.Transparent)
    }

}
